import * as Yup from 'yup';

export const exercisesSchema = Yup.object().shape({
  score: Yup.number().moreThan(0, 'Score should not be zero or less than zero'),
});
